export const refinePages = ({ total_pages, current_page }) => {
  if (total_pages === 0) return [1];
  const startPage = Math.max(2, current_page - 2); // 2부터 시작 (1은 항상 보여줌)
  const endPage = Math.min(total_pages - 1, current_page + 2); // 마지막 페이지는 항상 별도 처리

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  // 첫 페이지, 마지막 페이지 처리
  const withBoundaries = [1];
  if (startPage > 2) {
    withBoundaries.push("..."); // 첫 페이지와 시작 사이에 ...
  }
  withBoundaries.push(...pages);
  if (endPage < total_pages - 1) {
    withBoundaries.push("..."); // 끝 페이지와 마지막 사이에 ...
  }
  if (total_pages > 1) {
    withBoundaries.push(total_pages); // 마지막 페이지 추가
  }

  return withBoundaries;
};
